<div class="row" *ngIf="initialDataSource.length> 0 ; else noRequests ">
    <div class="col">
        <!-- Apply Filters -->
        <div class="d-flex justify-content-between justify-content-md-start mt-4
            mt-md-3 mb-3">
            <div class="form-inline">
                <div class="form-group
                    position-relative mb-0">
                    <input type="text" class="form-control"
                        placeholder="{{ 'pt.edp.edponline.table.search' |
                        translate}}"
                        (keyup)="onKeyPress($event, $event.target.value)">
                    <span class="wrapper-icon">
                        <i class="icon icon-edponline-Bop-055"  aria-hidden="true"></i>
                    </span>
                </div>
            </div>
            <div class="ml-5 form-inline flex-nowrap">
                <!-- Desktop List -->
                <div class="edp-select-list d-none d-md-block" role="group"
                    ngbDropdown>
                    <div class="edp-selected" ngbDropdownToggle>
                        <input type="text" class="form-control dropdown-input"
                            [value]="dropdownFormControl.controls['dropdown']?.value
                            | translate"
                            placeholder="{{ 'pt.edp.edponline.table.sort' |
                            translate}}" readonly>
                        <span class="select-icon">
                            <i class="icon icon-edponline-Bop-073"  aria-hidden="true"></i>
                        </span>
                    </div>
                    <ul class="select-list" ngbDropdownMenu>
                        <li *ngFor="let order of orderList; index as i"
                            class="select-item"
                            ngbDropdownItem
                            (click)="applyOrder(order);dropdownFormControl.controls['dropdown'].setValue(order.label)">
                            {{order.label | translate}}
                        </li>
                    </ul>
                </div>

                <!-- Mobile -->
                <div class="edp-select-list ml-auto d-block d-md-none"
                    role="group" ngbDropdown [autoClose]="'outside'">
                    <div class="edp-selected" ngbDropdownToggle>
                        <button class="btn btn-toggle">
                            <i class="icon-edponline-BopEO-020"  aria-hidden="true"></i>
                        </button>
                        <ul class="select-list custom-dropdown-options"
                            ngbDropdownMenu>
                            <span class="dropdown-label py-4 border-bottom"
                                ngbDropdownToggle>
                                {{ 'pt.edp.edponline.table.sort' | translate |
                                uppercase}}
                                <span class="float-right mr-4">
                                    <i class="icon-edponline-Bop-071"  aria-hidden="true"></i>
                                </span>
                            </span>
                            <li *ngFor="let order of orderList; index as i"
                                class="select-item dropdown-item"
                                ngbDropdownItem
                                (click)="dropdownFormControl.controls['dropdown'].setValue(order.label);
                                choiseOrder= order">
                                <div class="custom-control custom-radio">
                                    <input type="radio" id="customRadio-{{i}}"
                                        name="customRadio"
                                        class="custom-control-input">
                                    <label class="custom-control-label
                                        justify-content-start"
                                        for="customRadio-{{i}}">{{order.label |
                                        translate}}</label>
                                </div>
                            </li>
                            <button class="btn edp-btn-primary btn-dropdown"
                                (click)="applyOrder(choiseOrder)"
                                ngbDropdownToggle>
                                {{ 'pt.edp.edponline.table.apply' | translate |
                                uppercase}}
                            </button>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row my-0 my-md-5 no-gutters">
            <div class="col">
                <!-- Table Content -->
                <table aria-describedby="" class="table">
                    <thead>
                        <tr class="d-none d-md-table-row">
                            <th *ngFor="let column of columnsMetaData; let i=
                                index" scope="col">
                                <span class="font-weight-bold">{{column.title |
                                    translate | uppercase}}</span>
                            </th>
                            <th *ngFor="let action of actions"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- mobile -->
                        <ng-container *ngIf="isApp; else tableContainerDesktop">
                            <ng-container *ngFor="let item of dataSource; let
                                rowIndex= index">
                                <tr *ngFor="let action of actions;"
                                    class="d-flex flex-column"
                                    infiniteScroll [infiniteScrollDistance]="2"
                                    [infiniteScrollThrottle]="150"
                                    (scrolled)="onScroll()"
                                    [attr.data-index]="0"
                                    (click)="runAction(action, item, rowIndex,
                                    $event)">
                                    <td *ngFor="let column of columnsMetaData;
                                        let colIndex= index"
                                        class="d-flex {{ column.orderResponsive
                                        }}">
                                        <a [ngClass]="evalColumnClass(column,
                                            item)">
                                            {{column.translate ?
                                            (item[column.name] | translate) :
                                            item[column.name] | titlecase}}
                                        </a>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>

                        <!-- desktop -->
                        <ng-template #tableContainerDesktop>
                            <ng-container *ngFor="let item of dataSource; let
                                rowIndex= index">
                                <tr *ngFor="let action of actions" class="d-flex
                                    flex-column d-md-table-row flex-md-row"
                                    [attr.data-index]="0"
                                    (click)="runAction(action, item, rowIndex,
                                    $event)">
                                    <td *ngFor="let column of columnsMetaData;
                                        let colIndex= index"
                                        class="d-flex d-md-table-cell py-md-4 {{
                                        column.orderResponsive }}">
                                        <a [ngClass]="evalColumnClass(column,
                                            item)">
                                            {{column.translate ?
                                            (item[column.name] | translate) :
                                            item[column.name] | titlecase}}
                                        </a>
                                    </td>
                                    <td *ngFor="let action of actions"
                                        class="d-none d-md-table-cell">
                                        <button (click)="runAction(action, item,
                                            rowIndex, $event)"
                                            *ngIf="!action.condition ||
                                            runActionCondition(action, item,
                                            rowIndex)">
                                            <i class="icon {{action.icon}}"  aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<ng-template #noRequests>
    <div class="d-flex justify-content-start align-items-center flex-column
        bg-table py-5 h-100">
        <div class="text-center mt-5 pt-5">
            <h5>{{ noResultMessage?.title }}</h5>
            <p>{{ noResultMessage?.subtitle }}</p>
        </div>
    </div>
</ng-template>

<div class="row d-none d-md-block" *ngIf="currentDataSource.length>
    _source?.pageSize && !isApp">
    <div class="col-12">
        <div class="d-flex align-items-center">
            <div class="d-flex flex-fill justify-content-center">
                <ngb-pagination [collectionSize]="paginator.totalItems"
                    [maxSize]="paginator.maxSize"
                    [pageSize]="paginator.itemsPerPage"
                    [(page)]="paginator.currentPage" [rotate]="true"
                    (pageChange)="onPageChange($event)">

                    <ng-template ngbPaginationPrevious><i class="icon-edponline-Bop-073
                            rotate-90"
                            aria-hidden="true"></i>
                    </ng-template>
                    <ng-template ngbPaginationNext><i class="icon-edponline-Bop-073
                            rotate-270"
                            aria-hidden="true"></i>
                    </ng-template>
                </ngb-pagination>
            </div>
        </div>
    </div>
</div>